var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationMarkerIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.532.937a6.89 6.89 0 017.034.058C12.71 2.327 14.012 4.705 14 7.26c-.05 2.54-1.447 4.929-3.193 6.775a18.727 18.727 0 01-3.358 2.82A1.174 1.174 0 017.04 17a.82.82 0 01-.39-.119 18.515 18.515 0 01-4.839-4.547A9.28 9.28 0 010 7.134l.005-.273c.09-2.456 1.42-4.7 3.527-5.924zm4.375 4.098a2.346 2.346 0 00-2.594.52 2.455 2.455 0 00-.519 2.64 2.378 2.378 0 002.198 1.497 2.339 2.339 0 001.683-.702 2.43 2.43 0 00.694-1.712 2.423 2.423 0 00-1.462-2.243z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.532.937a6.89 6.89 0 017.034.058C12.71 2.327 14.012 4.705 14 7.26c-.05 2.54-1.447 4.929-3.193 6.775a18.727 18.727 0 01-3.358 2.82A1.174 1.174 0 017.04 17a.82.82 0 01-.39-.119 18.515 18.515 0 01-4.839-4.547A9.28 9.28 0 010 7.134l.005-.273c.09-2.456 1.42-4.7 3.527-5.924zm4.375 4.098a2.346 2.346 0 00-2.594.52 2.455 2.455 0 00-.519 2.64 2.378 2.378 0 002.198 1.497 2.339 2.339 0 001.683-.702 2.43 2.43 0 00.694-1.712 2.423 2.423 0 00-1.462-2.243z",
    fill: "#FFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 20c2.761 0 5-.448 5-1s-2.239-1-5-1-5 .448-5 1 2.239 1 5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 20c2.761 0 5-.448 5-1s-2.239-1-5-1-5 .448-5 1 2.239 1 5 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarkerIconWhite);
export default __webpack_public_path__ + "static/media/location-marker-icon-white.25fd0de0feacb47b7ad2972261034447.svg";
export { ForwardRef as ReactComponent };